import type { AccountBalance } from '../../generated-types';
import { currencyFormatter } from '../shared/numberFormat';

export const isLoanArrear = (accountBalace: AccountBalance) =>
    Math.abs(accountBalace.creditLimit) < Math.abs(accountBalace.accountingBalance) &&
    accountBalace.accountingBalance < 0;

export const getLoanArrearValue = (balance: AccountBalance | undefined) => {
    if (balance === undefined || !isLoanArrear(balance)) {
        return undefined;
    }
    return Math.abs(balance.creditLimit) - Math.abs(balance.accountingBalance);
};

export const getLoanArrear = (balance: AccountBalance | undefined) => {
    const diff = getLoanArrearValue(balance);
    return diff ? currencyFormatter(diff) : undefined;
};
